<template>
  <div class="img-wrapper" @mouseover="imgTileHover = true" @mouseleave="imgTileHover = false">
    <div class="blk-curtain" :class="{ show: imgTileHover }" @click="imgDialogFlg = true">
      <q-icon color="white" name="mdi-magnify-plus" />
    </div>
    <div class="img-area">
      <img :src="'data:image/svg+xml;base64,' + props.exatoms" alt="" />
    </div>
    <q-dialog v-model="imgDialogFlg" class="formula-dialog">
      <q-card>
        <q-btn v-close-popup flat round dense icon="close" />
        <q-card-section>
          <q-img :src="'data:image/svg+xml;base64,' + props.exatoms" />
        </q-card-section>
      </q-card>
    </q-dialog>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

interface Props {
  exatoms: string;
}
const props = defineProps<Props>();

const imgDialogFlg = ref(false);
const imgTileHover = ref(false);
</script>
<style scoped>
.img-wrapper {
  width: 100%;
  position: relative;
  background-color: var(--q-pureWhite);
}
.img-wrapper .blk-curtain.show {
  background-color: rgba(0, 0, 0, 0.2);
}
.img-wrapper .blk-curtain {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 20;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-end;
  cursor: pointer;
  justify-content: flex-end;
}

.img-wrapper .blk-curtain i {
  font-size: 60px;
  opacity: 0.8;
  display: none;
}

.img-wrapper .blk-curtain.show i {
  display: block;
}

.img-wrapper .blk-curtain i:hover {
  opacity: 1;
}

.img-area {
  display: flex;
  justify-content: center;
  height: 100%;
}

.searchresult-area .right-area .img-area img {
  width: auto;
  height: 100%;
  margin: 0 auto;
}

/* 化合式拡大 */
.formula-dialog .q-btn--dense.q-btn--round {
  position: absolute;
  right: 40px;
  top: 30px;
  cursor: pointer !important;
  transform: scale(2);
}

.formula-dialog .q-btn--dense.q-btn--round * {
  cursor: pointer !important;
}

.formula-dialog.q-dialog .q-dialog__inner .q-card {
  width: 620px;
  max-width: unset;
  min-height: unset;
  display: flex;
  align-items: center;
  justify-content: center;
}

.formula-dialog .q-card__section {
  width: 70%;
  /* max-width: 700px; */
  margin: 0 auto;
}
</style>
